import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { NotFoundComponent } from './core/pages/not-found/not-found.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
// can import modules from other packages ()
// ui lib
// lazy loading
// global routing guard for auth
// angular state management, ngrx, ngxs (localstorage)
// angular performance optimization (rendering strategies, change detection, lazy loading, preloading, )
// CDN
// BFF back for front
// page load time not affected by api loading
// code review
// atomic design
// UI/UX
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./feature/user/user.module').then(m => m.UserModule),
  },
  {
    path: '',
    loadChildren: () => import('./feature/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: '',
    loadChildren: () => import('./feature/authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: 'projects',
    loadChildren: () => import('./feature/project/project.module').then(m => m.ProjectModule),
  },
  {
    path: 'keys',
    loadChildren: () => import('./feature/key/key.module').then(m => m.KeyModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
